import { defineStaticListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const FLIGHT_RISK_SELECTIONS = [
  { value: '0', label: 'Very Low' },
  { value: '1', label: 'Low' },
  { value: '2', label: 'Medium' },
  { value: '3', label: 'High' },
  { value: '4', label: 'Very High' },
];

export const flightRiskDescriptor = defineStaticListFilter({
  definition: {
    id: FilterId.FLIGHT_RISK,
    name: 'Flight Risk',
    type: FilterType.STATIC_LIST,
    selections: [],
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_FLIGHT_RISK },
});
